import React, { FC, useContext } from 'react'
import { useOnAirState, TheWestLiveContext } from '../TheWestLiveProvider'
import { LivePlayerButtonOnly } from '../TheWestLivePlayer/TheWestLivePlayerSkin/TheWestLivePlayerSkin'
import {
    StyledWestLiveInArticleBannerContainer,
    StyledWestLiveInArticleLogo,
    StyledWestLiveInArticleBannerText,
    StyledWestLiveInArticlePlayer,
    StyledWestLiveInArticleBannerLogoContainer,
} from './TheWestLiveInArticleBanner.styled'
import { toRadioEvent } from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'
import { TheWestLiveWaves } from '../TheWestLiveWaves/TheWestLiveWaves'

export const TheWestLiveInArticleBanner: FC = () => {
    const { onAir, broadcast } = useOnAirState()
    const { playerState, setPlayerState, onEvent } = useContext(
        TheWestLiveContext,
    )

    function handleControlClick() {
        setPlayerState({
            ...playerState,
            state: playerState.state === 'stopped' ? 'loading' : 'stopped',
        })

        onEvent(
            toRadioEvent(
                playerState.state === 'stopped'
                    ? DataLayerEventName.radioPlay
                    : DataLayerEventName.radioStop,
                broadcast,
                'card',
            ),
        )
    }

    if (!onAir) {
        return null
    }

    return (
        <StyledWestLiveInArticleBannerContainer>
            <StyledWestLiveInArticleBannerLogoContainer>
                <StyledWestLiveInArticleLogo />
                <StyledWestLiveInArticleBannerText>
                    We are live. Tune in.
                </StyledWestLiveInArticleBannerText>
            </StyledWestLiveInArticleBannerLogoContainer>
            <StyledWestLiveInArticlePlayer
                PlayerSkin={(props) => (
                    <LivePlayerButtonOnly
                        {...props}
                        onControlClick={handleControlClick}
                    />
                )}
            />
            <TheWestLiveWaves />
        </StyledWestLiveInArticleBannerContainer>
    )
}
TheWestLiveInArticleBanner.displayName = 'TheWestLiveInArticleBanner'

export default TheWestLiveInArticleBanner
